import { createContext, useContext } from "react";
import type { ReferenceDocumentView } from "@/lib/api/generated/casedb";

export interface AssessmentReferenceContextValue {
  dailyMedUrlByDatasheetRecordId: Record<string, string>;
  referenceDocumentsByDatasheetRecordId: Record<string, ReferenceDocumentView[]>;
}

const EMPTY_REFERENCE_CONTEXT: AssessmentReferenceContextValue = {
  dailyMedUrlByDatasheetRecordId: {},
  referenceDocumentsByDatasheetRecordId: {},
};

/**
 * The listedness evidence for every datasheet row in the active relationship, keyed by the
 * datasheet's own record id.
 *
 * <p>Defaults to empty rather than requiring a provider: {@link AssessmentReferenceRenderer} also
 * has to render correctly in isolation (catalog override coverage, storybook-style renders) where
 * no datasheet evidence exists at all — that is the "no source" case, not a wiring error.
 */
export const AssessmentReferenceContext =
  createContext<AssessmentReferenceContextValue>(EMPTY_REFERENCE_CONTEXT);

export function useAssessmentReference(): AssessmentReferenceContextValue {
  return useContext(AssessmentReferenceContext);
}
